<template>
  <div class="section">
    <div class="inner">
      <div class="summarize">
        <div style="padding: 70px 30px 30px 40px">
          从以上分析可以看出，测试者现阶段：
        </div>
        <!------------------ 良好 -------------------------------->
        <div style="padding: 0px 30px 10px 40px">
          <img :src="images.good" style="height: auto; width: 7%" />
          <p
            style="
              font-weight: bold;
              color: #26bcb8;
              font-size: 20px;
              margin-left: 60px;
              margin-top: -40px;
            "
          >
            能力较为突出的方面
          </p>
        </div>

        <div
          style="margin-left: 100px; margin-right: 210px; line-height: 25px"
          v-if="this.good.length != 0"
        >
          <div
            v-for="(item, index) in this.good"
            :key="index"
            style="display: inline"
          >
            <span style="display: inline" v-if="index != good.length - 1">
              {{ item.name }}、
            </span>
            <span style="display: inline" v-else> {{ item.name }}。</span>
          </div>
        </div>

        <div style="margin-left: 100px" v-if="this.good.length == 0">无</div>
        <!------------------ 较差 -------------------------------->
        <div style="padding: 20px 30px 10px 40px">
          <img :src="images.jiaocha" style="height: auto; width: 7%" />
          <p
            style="
              font-weight: bold;
              color: #26bcb8;
              font-size: 20px;
              margin-left: 60px;
              margin-top: -40px;
            "
          >
            能力较差的方面
          </p>
        </div>

        <div
          style="margin-left: 100px; margin-right: 210px; line-height: 25px"
          v-if="this.jiaocha.length != 0"
        >
          <div
            v-for="(item, index) in this.jiaocha"
            :key="index"
            style="display: inline"
          >
            <span style="display: inline" v-if="index != jiaocha.length - 1">
              {{ item.name }}、
            </span>
            <span style="display: inline" v-else> {{ item.name }}。 </span>
          </div>
        </div>

        <div style="margin-left: 100px" v-if="this.jiaocha.length == 0">无</div>

        <!------------------ 差不多 -------------------------------->
        <div style="padding: 20px 30px 10px 40px">
          <img :src="images.chabuduo" style="height: auto; width: 7%" />
          <p
            style="
              font-weight: bold;
              color: #26bcb8;
              font-size: 20px;
              margin-left: 60px;
              margin-top: -40px;
            "
          >
            能力一般的方面
          </p>
        </div>
        <div
          style="margin-left: 100px; margin-right: 210px; line-height: 25px"
          v-if="this.chabuduo.length != 0"
        >
          <div
            v-for="(item, index) in this.chabuduo"
            :key="index"
            style="display: inline"
          >
            <span style="display: inline" v-if="index != chabuduo.length - 1">
              {{ item.name }}、
            </span>
            <span style="display: inline" v-else> {{ item.name }}。 </span>
          </div>
        </div>

        <div style="margin-left: 100px" v-if="this.chabuduo.length == 0">
          无
        </div>

        <div class="fixpage-bg">
          <img :src="images.paback" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageFour } from "@/views/report/config/three";

export default {
  props: ["model", "behaviorResult", "beScore"],

  data() {
    return {
      images: {
        logo: require("../../../../assets/images/page1/logo.png"),
        bg: require("../../../../assets/images/page7/bg.png"),
        page: require("../../../../assets/images/page7/page.png"),
        title: require("../../../../assets/images/page7/title.png"),
        good: require("../../../../assets/images/page7/good.png"),
        chabuduo: require("../../../../assets/images/page7/chabuduo.png"),
        jiaocha: require("../../../../assets/images/page7/jiaocha.png"),
        paback: require("../../../../assets/images/page7/paback.png"),
        page6: require("../../../../assets/images/page7/page6.png"),
      },
      chabuduo: [], // 4-7 分
      jiaocha: [], // 1-3 分
      good: [], // 8-10 分
      value: {}, //监控数据
      content1: pageFour.content1,
      SectionviewData: pageFour.SectionviewData,
    };
  },
  watch: {
    behaviorResult(val) {
      this.behaviorResult = val;
      this.panduan();
    },
  },
  methods: {
    panduan() {
      this.behaviorResult.level2.map((item) => {
        if (
          item.score == 0 ||
          item.score == 1 ||
          item.score == 2 ||
          item.score == 3
        ) {
          this.jiaocha.push({
            name: item.name,
            score: item.score,
          });
        } else if (
          item.score == 4 ||
          item.score == 5 ||
          item.score == 6 ||
          item.score == 7
        ) {
          this.chabuduo.push({
            name: item.name,
            score: item.score,
          });
        } else {
          this.good.push({
            name: item.name,
            score: item.score,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  // height: 1124px; //A4纸的高度像素
  page-break-inside: avoid;
}
.inner {
  position: relative;
  background-size: 300px !important;
  background-repeat: no-repeat;
}

.summarize {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px;
  position: relative;
}
.fixpage-bg {
  float: right;
  width: 100%;
  background-color: white;
  position: absolute;
  bottom: 0px;
}
.fixpage-bg img {
  height: auto;
  width: 25%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/behavior/pageFive.vue